import { memo } from "react";
import { useSelector } from "react-redux";
import clsx from "clsx";
import { makeStyles } from "@mui/styles";
import { Grid } from "@mui/material";
import LocationOnIcon from "@mui/icons-material/LocationOn";

import { pickupVolumesSelector } from "../../../reducers/matrixProfile/selectors";
import { getParcels } from "../../../utils/routes";

import { View } from "../../View";
import { ParcelIcon } from "../../Icons";

const useStyles = makeStyles({
  container: {
    maxHeight: "40px",
    width: "55px",
  },
  line: {
    display: "flex",
    height: "12px",
    lineHeight: "12px",
    fontSize: "12px",
  },
  icon: {
    color: "white",
    height: "12px",
    width: "12px",
  },
  iconContainer: {
    paddingLeft: "4px",
  },
  green: {
    backgroundColor: "#8AC149",
  },
  top: {
    borderRadius: "0 0.125rem 0 0",
  },
  marginTop: {
    marginTop: "2px",
  },
});

export const PickupVolumes = memo(
  ({ routeCode = null, postcode, pickupConfig, showNoVolume = false }) => {
    const styles = useStyles();
    const pickupVolumes = useSelector(pickupVolumesSelector);
    const stops = pickupVolumes?.[routeCode]?.[postcode] || [];
    const parcels = getParcels({ stops }) || 0;

    if (
      !showNoVolume &&
      ((!routeCode && Object.keys(pickupConfig.configByRouteCode).length) ||
        !stops.length)
    )
      return null;
    else
      return (
        <Grid container item direction={"column"} className={styles.container}>
          <Grid item container justifyContent={"flex-column"}>
            <Grid
              item
              className={clsx(styles.line)}
              container
              justifyContent={"flex-end"}
            >
              {stops.length}
              <View className={clsx(styles.iconContainer, styles.top)}>
                <LocationOnIcon className={clsx(styles.icon, styles.green)} />
              </View>
            </Grid>
            <Grid
              item
              className={clsx(styles.line, styles.marginTop)}
              container
              justifyContent={"flex-end"}
            >
              {parcels}
              <View className={clsx(styles.iconContainer, styles.top)}>
                <ParcelIcon className={clsx(styles.icon, styles.green)} />
              </View>
            </Grid>
          </Grid>
        </Grid>
      );
  }
);
